/**
 * Утилита для определения, является ли запрос от Prerender сервиса
 * Prerender использует специальный User-Agent с идентификатором "Prerender-Bot"
 */
export function isPrerender(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return false;
  }
  
  const userAgent = navigator.userAgent || '';
  return userAgent.includes('Prerender-Bot');
}

